export default "__VITE_PUBLIC_ASSET__32b862d2__"